<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* margin: 0;
  padding: 0; */
  -webkit-appearance: none;
}
input{
  -webkit-appearance:none;
}
input::-ms-clear,
input::-ms-reveal {
  display: none;
}
input::-webkit-credentials-auto-fill-button {
    display: none !important;
    visibility: hidden;
    pointer-events: none;
    position: absolute; 
    right: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue